import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
var ObjectUtils = /*#__PURE__*/function () {
  function ObjectUtils() {
    _classCallCheck(this, ObjectUtils);
  }
  _createClass(ObjectUtils, null, [{
    key: "isRenderable",
    value: function isRenderable(value) {
      if (value === true) {
        return true;
      }
      return !_isNil(value) && (!_isEmpty(value) || _isNumber(value));
    }
  }]);
  return ObjectUtils;
}();
export default ObjectUtils;